"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const ContactAlreadyExistsError_1 = __importDefault(require("./errors/ContactAlreadyExistsError"));
const ContactBodyNotValidError_1 = __importDefault(require("./errors/ContactBodyNotValidError"));
const ContactDoesNotExistError_1 = __importDefault(require("./errors/ContactDoesNotExistError"));
/**
 * TutoringServiceClient
 * @param {any} fetch an object implementing the fetch api (for browsers this can be fetch.bind() for node require('node-fetch'))
 * @param {Object} options options object input data and dependency injection
 * @param {Object} options.fetch change fetch method from whatwg-fetch (optional, default: whatwg-fetch)
 * @param {string} options.protocol the http protocol of the service endpoint
 * @param {string} options.host the host of the service endpoint
 * @param {string} options.path the path of the service endpoint (optional)
 * @param {number} options.retries the number of times the client should retry on network error / service error (optional, default: 3)
 * @param {number} options.delayInSecs the delay between retries (optional, default: 2)
 * @param {Object} options.credentials identifiers and secrets required to hit protected endpoints (optional)
 * @param {string} options.region states the region of the service for signing (optional, default: eu-west-1)
 * @param {RequestMaker} options.requestMaker for overriding request making logic (optional, default: RequestMaker)
 * @throws {UrlConstructionError} when either options.protocol or options.host is missing
 */
class TutoringServiceClient extends client_library_1.Client {
    constructor(fetch, options = {}) {
        super(fetch, options);
    }
    async _makeCommonRequest(baseUrl, method, path, body) {
        let url = this._constructUrl(baseUrl);
        if (path) {
            url += `/${path}`;
        }
        const expectedResponses = [200, 201, 204, 400, 404, 409, 422];
        const options = { method };
        if (body) {
            options.body = JSON.stringify(body);
        }
        return this.requestMaker.makeRequest(url, options, expectedResponses);
    }
    async _makeContactRequest(method, url, path, body) {
        const response = await this._makeCommonRequest(url, method, path, body);
        if (response.status === 422) {
            const body = response.json;
            throw new ContactBodyNotValidError_1.default(body.pointer, body.reason);
        }
        if (response.status === 404) {
            throw new ContactDoesNotExistError_1.default('email', path);
        }
        if (response.status === 409) {
            throw new ContactAlreadyExistsError_1.default(body.email);
        }
        if (response.status === 200 || response.status === 201) {
            return response.json;
        }
        // else 204 no exception or response body
        return;
    }
    /**
     * Creates a new contact in third party sales client
     * @param {Object} contactProperties properties of a contact
     * @throws {UnexpectedServerResponse} when service returns an unexpected response
     * @throws {RequestLimitExceeded} when the max number of retries has been hit
     * @returns {Promise.<void>}
     */
    async createContact(contactProperties) {
        await this._makeContactRequest('POST', 'api/contact', null, Object.assign({}, contactProperties));
    }
    /**
     * Fetches user tutoring lead
     * @returns {Promise.<UserTutoringLeadI>}
     */
    async fetchMyContact() {
        return this._makeContactRequest('GET', 'api/contact/me');
    }
    /**
     * Updates an existing contact in third party sales client
     * @param {Object} contactProperties properties of a contact
     * @returns {Promise.<void>}
     */
    async updateContact(contactProperties) {
        await this._makeContactRequest('PATCH', 'api/contact', null, Object.assign({}, contactProperties));
    }
    _constructUrl(path) {
        let url = this.url;
        if (!this.url.endsWith('/')) {
            url += '/';
        }
        url += path;
        return url;
    }
}
exports.default = TutoringServiceClient;
//# sourceMappingURL=TutoringServiceClient.js.map